import React from "react";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";

interface DA_BasicLinkWrapperProps {
    href?: string;
    target?: "_blank" | "_self";
    className?: string;
    children: React.ReactNode;
}

export const DA_BasicLinkWrapper = ({ href, ...props }: DA_BasicLinkWrapperProps) => {
    if (href) {
        return <DA_BasicLink href={href} {...props} />;
    }

    return <div {...props} />;
};
